import styled from '@emotion/styled';
import React from 'react';
import Text from './text';
import { theme } from 'styles/theme/theme';

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  headerText?: string;
}

function Block(props: IProps) {
  const { children, headerText, ...rest } = props;

  return (
    <MainBlock {...rest}>
      <Text color={theme.colors.Gray} size={'medium'}>
        {headerText}
      </Text>
      {children}
    </MainBlock>
  );
}

export default Block;

const MainBlock = styled.div`
  width: 100%;
  padding-inline: 16px;
  padding-block: 6px;
  background: ${theme.colors.Blue};
  gap: 8px;

  display: flex;

  position: relative;
`;
